export class LegalAgreements {
  // Route paths for the DB-backed legal documents served publicly by the
  // Authority portal (e.g. https://login.goatness.app/legal/terms). Apps other
  // than Authority prefix these with their environment.authorityPortalUrl.
  static readonly TERMS_PATH = '/legal/terms';
  static readonly PRIVACY_PATH = '/legal/privacy';
}
